/**
 * Labstep
 *
 * @module state/slices/jupyter
 * @desc Selectors for Jupyter
 */

import { combineReducers } from '@reduxjs/toolkit';
import type { JupyterAuthorizeState } from 'labstep-web/state/slices/jupyter/authorize/types';
import type { JupyterInstanceState } from 'labstep-web/state/slices/jupyter/jupyterInstance/types';
import { jupyterAuthorizeSlice } from './authorize';
import { jupyterInstanceSlice } from './jupyterInstance';

export interface StateJupyter {
  authorize: JupyterAuthorizeState;
  jupyter_instance: JupyterInstanceState;
}

export const jupyterReducers = combineReducers({
  authorize: jupyterAuthorizeSlice.reducer,
  jupyter_instance: jupyterInstanceSlice.reducer,
});
